/*global $*/
import React from "react";
import { connect } from "react-redux";

import { goTo } from "../tools";
import { authentication } from "../app-database";

const mapState = (state) => {
	return {
		msj: state.miPerfil.msjEliminar,
		encabezado: state.miPerfil.encabezadoEliminar,
		borradaFlag: state.miPerfil.cuentaBorrada
	};
};

const mapDispatch = (dispatch) => {
	return {
		resetPaso: () => {
			dispatch({ "type": "MI_PERFIL_RESET_SIGUIENTE_ELIMINAR" });
		},
		addEvento: (evento) => {
			dispatch({ "type": "MI_PERFIL_SET_EVENT", "evento": evento});
		}
	};
};

class PasoTresEliminarCuenta extends React.Component {
	state = {}

	ok = () => {
		$("#modal-eliminar-cuenta").modal("toggle");
		this.props.addEvento("CuentaEliminada-EliminarCuenta");
		this.props.resetPaso();
		authentication.signOut().then(function() {
			goTo("login");
		}, function(error) {
			console.error("Sign Out Error", error);
		});
	}
	
	render() {
		return <div>
			<h5>
				<i>
					<img src={ require("../img/trash.png") } />
				</i>{this.props.encabezado}
			</h5>
			<hr className="mt-34" />
			<div className="texto-17">
				<p>{this.props.msj}</p>
			</div>
			<div className="row">
				<div className="col-xs-12">
					<div className="text-center aceptar-cancelar-btn mt-50">
						<a onClick={this.ok} className="orange-btn">Aceptar</a>
					</div>
				</div>
			</div>
		</div>;
	}
}

export default connect(mapState, mapDispatch)(PasoTresEliminarCuenta);


// WEBPACK FOOTER //
// ./src/miPerfil/pasoTresEliminarCuenta.cmpt.js